import {IssueStatus} from "../domain/entities/issue-status.entity";
import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";

/**
 * Command to create a new issue status entity.
 */
export class CreateIssueStatusCommand extends AbstractCommand<IssueStatus> {

    public name = CommandName.CREATE_ISSUE_STATUS;

    public tags: string[] = [`entity`, `create`, `issue-status`];

    constructor(payload: IssueStatus) {
        super('issue-status', payload.uid, payload);
    }
}
